<div class='finance-awards-page'>

	<toolbar icon='Experience'>

		<!-- 
		<button class="btn btn-light">
			<icon-text [iconContext]='{ text: "Monkey", iconClass: "fa-monkey", iconStyle:"fa-regular", hideText: "lt-md" }'></icon-text>
		</button>

		<button class="btn btn-light">
			<icon-text [iconContext]='{ text: "Pizza", iconClass: "fa-pizza-slice", iconStyle:"fa-regular", hideText: "lt-lg" }'></icon-text>
		</button> -->

	</toolbar>

	<page-tabs [tabNames]='["Awards", "Tab1", "Tab2"]' [pageService]='pageService' (layoutChange)='onLayoutChange($event)'>
		
		<ng-template pageTab1>
			<finance-awards-views-part></finance-awards-views-part>
		</ng-template>

		<ng-template pageTab2>
			<finance-awards-tab-1-part></finance-awards-tab-1-part>
		</ng-template>

		<ng-template pageTab3>
			<finance-awards-tab-2-part></finance-awards-tab-2-part>
		</ng-template>
	</page-tabs>

</div>